import { DefaultValidator } from '../'
import { translateValidator } from '../../i18next/i18nextHelpers'
import { withDefaultValidator } from '../formValidators.utils'

const validDateTranslateKey = 'validator.validDate'

export const validDate = (day: number, month: number, year: number) => {
  const date = new Date(year, month, day)

  return (
    !isNaN(date.getTime()) &&
    date.getDate() === day &&
    date.getMonth() === month &&
    date.getFullYear() === year
  )
}

export const validDate2 = (date: string) => {
  return !isNaN(new Date(date).getTime())
}

export const validDateTranslated: DefaultValidator = withDefaultValidator(
  (localeKey?: string) =>
    translateValidator(validDate, localeKey || validDateTranslateKey),
)
